export default __webpack_public_path__ + "454e25405a21d358dcdae6b7befa18d6.obj";